import { handleFormikValueChange, Select } from "lcm-iot-commons";

type Props = {
  valueArrayName: string;
  objIdx: number;
  values: {
    availableVariables?: $TSFixMe;
    modbusConfig?: $TSFixMe;
    allAvailableVariables?: $TSFixMe;
  };
};

export function FieldGatewayModbusVariableSelect(props: Props) {
  const { valueArrayName, objIdx, values } = props;

  return (
    <Select
      {...props}
      options={values.allAvailableVariables}
      // @ts-expect-error TS(7053) FIXME: Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
      selectedOption={values[valueArrayName][objIdx].regName || null}
      onChange={(value) => {
        handleFormikValueChange(props, value);
      }}
      // @ts-expect-error TS(2322) FIXME: Type '{ options: any; selectedOption: any; onChang... Remove this comment to see the full error message
      required
      input
    />
  );
}

export default FieldGatewayModbusVariableSelect;
